import { DataTable } from '@ui';
import { SortDescriptor } from '@ds';
import { ReactNode } from 'react';

type EmployeeKey = {
  employeeId: string;
};

type TableColumnType = {
  key: string;
  label: string | ReactNode;
  isSortable: boolean;
  minWidthClassName?: string;
  tooltipText?: string;
};

type CandidatesTableProps<T extends EmployeeKey> = {
  columns: TableColumnType[];
  renderCell: (item: T, columnKey: string) => ReactNode;
  data: T[];
  isLoading: boolean;
  isFetching: boolean;
  sortBy?: SortDescriptor;
  label: string;
  className?: string;
  onSortByChange?: (sortBy: SortDescriptor) => void;
};

export const CandidatesTable = <T extends EmployeeKey>({
  columns,
  renderCell,
  data,
  isLoading,
  isFetching,
  sortBy,
  onSortByChange,
  label,
  className,
}: CandidatesTableProps<T>) => {
  return (
    <DataTable
      label={label}
      columns={columns}
      renderCell={renderCell}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      sortBy={sortBy}
      onSortByChange={onSortByChange}
      baseClassName={className ?? 'min-h-[400px] max-h-[400px]'}
      idKey="employeeId"
      type="infinite"
      hidePadding
      isHeaderSticky
    />
  );
};
